import MicroModal from 'micromodal';
import Swiper from 'swiper/bundle';

const Search = {
  swipers: [],

  initSwipers: function () {
    [
      {
        container: '.modal__section--collections .modal__row',
        prevEl: '.modal__section--collections .modal__nav--prev',
        nextEl: '.modal__section--collections .modal__nav--next',
      },
      {
        container: '.modal__section--atelier .modal__row',
        prevEl: '.modal__section--atelier .modal__nav--prev',
        nextEl: '.modal__section--atelier .modal__nav--next',
      },
    ].forEach(({ container, prevEl, nextEl }) => {
      const el = document.querySelector(container);
      if (!el) return;

      this.swipers.push(
        new Swiper(el, {
          centeredSlides: false,
          spaceBetween: 0,
          slidesPerView: 'auto',
          effect: 'slide',
          parallax: true,
          speed: 600,
          loop: true,
          autoplay: false,
          grabCursor: false,
          simulateTouch: true,
          allowTouchMove: true,
          navigation: { prevEl, nextEl },
        }),
      );
    });
  },

  bindCollectionLinks: function () {
    const modal = document.getElementById('modal-quick-reference');
    if (!modal) return;

    modal.addEventListener('click', function (e) {
      const card = e.target.closest('.modal__section--collections .modal__card');
      if (!card) return;

      const href = card.getAttribute('href');
      if (!href || !href.startsWith('/wine#')) return;

      if (window.location.pathname === '/wine') {
        e.preventDefault();
        window.location.href = href;
        window.location.reload();
      }
    });
  },

  init: function () {
    const self = this;
    let swipersReady = false;

    this.bindCollectionLinks();

    MicroModal.init({
      openTrigger: 'data-micromodal-trigger',
      closeTrigger: 'data-micromodal-close',
      openClass: 'is-open',
      disableScroll: false,
      awaitOpenAnimation: true,
      awaitCloseAnimation: true,
      onShow: () => {
        document.body.classList.add('modal-open');
        if (!swipersReady) {
          self.initSwipers();
          swipersReady = true;
        } else {
          self.swipers.forEach((s) => s.update());
        }
      },
      onClose: () => document.body.classList.remove('modal-open'),
    });
  },
};

export default Search;
